
import { Vue, Component } from 'vue-property-decorator';
import { Form, Field, Button, Toast } from 'vant';
import { getBaseInfo } from '../api';

Vue.use(Form).use(Button);
Vue.use(Field);
@Component
export default class Rule extends Vue {
  username: string = '';
  password: string = '';
  async onSubmit(values: any) {
    if (!this.username || !this.password) {
      return false;
    }
    const data = {
      username: this.username,
      password: this.password,
    };
    const res: any = await getBaseInfo(data);
    if (res.statusCode === 200) {
      Toast.success('登陆成功！');
      localStorage.setItem('0420BMB_token', res.data.token);
      this.$router.push('home');
    } else {
      Toast.fail(res.message);
    }
  }
}
